import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

export const fetchAndLogStatus = (url: string, logger: ClientLogger, failureMessage: string, successMessage?: string) =>
  fetch(url)
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        if (successMessage) {
          logger.logEvent(new SystemEvent(SystemEventLevel.INFO, successMessage), ` URL=[${url}]`);
        }
      } else {
        logFailureMessage(url, logger, `${failureMessage} status=${response.status}`);
      }
    })
    .catch(() => {
      logFailureMessage(url, logger, failureMessage);
    });

const logFailureMessage = (url: string, logger: ClientLogger, failureMessage: string) => {
  logger.logEvent(new SystemEvent(SystemEventLevel.WARN, failureMessage), ` URL=[${url}]`);
};
